
import settings from '../../components/settings'

/* eslint-disable no-underscore-dangle */

export const useMyProjectCustomer = () => fetch(
    `${settings.badaAppointmentApiUrl}/customer/`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: window.__OMNI__?.access_token
          ? `Bearer ${window.__OMNI__.access_token}`
          : undefined,
      },
    }
  ).then((r) => r.json())